module.exports = __webpack_public_path__ + "static/media/send-on.5935d06e.svg";